module.exports = __webpack_public_path__ + "img/ar_m_1.3b006055.png";